import React, { useState } from "react";
import Label from "lib/Label";
import "./index.scss";
import { useEffect } from "react";
import { Col } from "react-bootstrap";
import ErrorMessage from "lib/ErrorMessage";
import { useDispatch, useSelector } from "react-redux";
import { getGeolocations } from "api/formDisplay";
import LoadingSpinner from "lib/LoadingSpinner";
import UploadSpinner from "lib/uploadSpinner";

const Location = (props) => {
  const {
    setSelectedData,
    placeholder,
    label,
    type,
    value,
    onChange,
    rows,
    cols,
    maxLength,
    className,
    label_style,
    name,
    size,
    is_disabled,
    autofill,
    validators,
    autofocus,
    isEditable,
    error,
  } = props;

  const errActive = error && error?.length !== 0;
  const errorClass = errActive ? "error_outline" : "";
  const dispatch = useDispatch();
   const [loader, setLoading] = useState(false);
   const organisation_id = useSelector(state => state.configurationReducer.config.organisation_id);
   const decryptedId = useSelector((state) => state.urlEncryption?.urlId);
   const userInfo = {
    userId: decryptedId.userId,
    primaryWorkflowId: decryptedId.primaryWorkflowId,
    subWfId: decryptedId.subWfId,
   
  };

  useEffect(() => {
      setLoading(true);
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(async (position) => {
          let Latitude = position.coords.latitude.toString();
          let Longitude = position.coords.longitude.toString();
          let response = await dispatch(
            getGeolocations({ organisation_id,autofill, Latitude, Longitude ,primary_workflow_id: userInfo?.primaryWorkflowId,  subWfId: userInfo?.subWfId})
          ).unwrap();
          setLoading(false);
          if (response?.status === "success") {
            autofill?.forEach((item) => {
              dispatch(
                setSelectedData({
                  key: [`${item?.destination_field}`],
                  value: response?.data?.[`${item?.source_field}`],
                })
              );
            });
          }
        });
      } else {
        throw new Error("Location is not Supported by Browser");
     }   
  }, []);

  return (
    <div className={size}>
      <Label label={label} className={label_style} validators={validators} />
      {loader ? (
        <div className="position-relative">
          <textarea
            type={type}
            name={name}
            className={`form-input form-input-spinner`}
            placeholder={placeholder}
          />
          <div class="spin-loader position-absolute">Loading...</div>
        </div>
      ) : (
        <textarea
          name={name}
          placeholder={placeholder}
          className={`form-textarea ${
            !isEditable && "radioDisabled"
          }  ${errorClass}`}
          value={value}
          onChange={onChange}
          rows={rows}
          cols={cols}
          maxLength={maxLength}
          is_disabled={is_disabled}
        ></textarea>
      )}
      {error?.length !== 0 && <ErrorMessage error={error} />}
    </div>
  );
};

export default Location;
